// const baseUrl = process.env.REACT_APP_BASE_URL;
// const liveUrl = "https://dev.teksun.com/smarttouch_new"
// http://localhost:6001
export const redirectUrl = "/smarttouch-admin";
export const TIME_STAMP = "1615971782";
export const NONCE = "35A90B73C39D97";
export const roomTypeBucketUrl =
  "https://smarttouchroom.s3.ap-south-1.amazonaws.com/";
export const iconBucketUrl =
  "https://smarttouchswitchicon.s3.ap-south-1.amazonaws.com/";
// export const baseUrl = "https://dev.teksun.com/smarttouch_new";
export const baseUrl = "https://fota.rapidise.tech/backend";
export const verifyUserUrl = baseUrl + "/api/v1/auth";
export const verifyOwnerUrl = baseUrl + "/api/v1/owner";
export const processMsg = "Processing...!";
export const logoutMsg = "Loggedin with same credentials form another device."

export const myHeaderStyle = {
  fontWeight: 600,
  color: "#b5b5c3",
  fontSize: ".9rem",
  textTransform: "uppercase",
  letterSpacing: ".1rem"
};
export const mySearchFieldStyle = {
  padding: "4px",
  backgroundClip: "padding-box",
  border: "1px solid #ced4da",
  borderRadius: "0.30rem"
};

export const CommonUrl = {
  masterUserBaseUrl: baseUrl + "/api/admin/master-users",
  subUserBaseUrl: baseUrl + "/api/admin/master-users",
  iconBaseUrl: baseUrl + "/api/admin/icons",
  roomTypeBaseUrl: baseUrl + "/api/admin/room-type",
  devicesBaseUrl: baseUrl + "/api/admin/devices",
  faqBaseUrl: baseUrl + "/api/admin/faq",
  defaultSettingsBaseUrl: baseUrl + "/api/admin/settings",
  dashboardBaseUrl: baseUrl + "/api/admin/dashboard",
  loginBaseUrl: baseUrl + "/api/admin/auth",
  forgotPassBaseUrl: baseUrl + "/api/admin/auth",
  resetPaswordBaseUrl: baseUrl + "/api/admin/auth",
  firmwareBaseUrl: baseUrl + "/api/admin/firmware-file",
  appliancesBaseUrl: baseUrl + "/api/admin/device-appliances"
};
